import { makeStyles, Theme, createStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            display: 'flex',
            flexDirection: 'column',
            gap: 24,
            width: '100%',
            minWidth: 0,
            boxSizing: 'border-box',
        },
        label: {
            color: '#0E1247',
            fontSize: 14,
            fontFamily: 'Poppins',
            fontWeight: 700,
            lineHeight: 1.4,
            marginBottom: 2,
        },
        formInput: {
            width: '100%',
            minWidth: 0,
            '& .MuiOutlinedInput-root': {
                borderRadius: 4,
                fontFamily: 'Poppins',
                fontSize: 14,
                color: '#0E1247',
            },
            '& .MuiOutlinedInput-notchedOutline': {
                borderColor: '#CDCEDA',
            },
            '& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline': {
                borderColor: '#CDCEDA',
            },
            '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
                borderColor: '#CDCEDA',
            },
        },
        fieldWrapper: {
            width: '100%',
            minWidth: 0,
            boxSizing: 'border-box',
        },
        titleFieldRow: {
            display: 'flex',
            alignItems: 'center',
            gap: 8,
            width: '100%',
            minWidth: 0,
            '& $formInput': {
                flex: 1,
            },
        },
        iconDelete: {
            color: '#FF4E4E',
            padding: 4,
            flexShrink: 0,
        },
        require: {
            fontSize: 13,
            marginTop: 4,
            color: '#FF4E4E',
        },
        textDelete: {
            fontSize: 15,
        },
        delete: {
            width: 150,
            border: '1px solid #BCBCBC',
            color: '#FF4E4E',
            padding: '0.5vh 0',
            margin: '0 auto',
            borderRadius: 7,
            cursor: 'pointer',
            fontWeight: 300,
        },
        iconUploadLabel: {
            color: '#2D3648',
            fontSize: 14,
            fontFamily: 'Poppins',
            fontWeight: 700,
            lineHeight: '16px',
            marginBottom: 8,
        },
        iconUploadZone: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            width: '100%',
            maxWidth: '100%',
            height: 160,
            boxSizing: 'border-box',
            border: '1px dashed #D8D8D8',
            borderRadius: 4,
            backgroundColor: '#F4F4F4',
            cursor: 'pointer',
            outline: 'none',
            transition: 'border-color 0.2s ease',
            '&:hover': {
                borderColor: '#9799B1',
            },
        },
        iconUploadZoneDisabled: {
            cursor: 'not-allowed',
            opacity: 0.7,
        },
        iconUploadZoneContent: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: 8,
        },
        iconUploadZoneIconWrap: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            width: 40,
            height: 40,
            borderRadius: 16,
            backgroundColor: '#EAE9EA',
        },
        iconUploadZoneIcon: {
            width: 24,
            height: 24,
        },
        iconUploadZoneTitle: {
            fontFamily: 'Poppins',
            fontSize: 14,
            fontWeight: 600,
            lineHeight: '24px',
            color: '#383838',
            textAlign: 'center',
        },
        iconUploadZoneHint: {
            fontFamily: 'Poppins',
            fontSize: 12,
            fontWeight: 600,
            lineHeight: '16px',
            color: '#838183',
            textAlign: 'center',
        },
        iconUploadedBox: {
            display: 'flex',
            alignItems: 'center',
            gap: 16,
            width: '100%',
            maxWidth: '100%',
            height: 64,
            boxSizing: 'border-box',
            padding: '8px 16px',
            border: '1px solid #D8D8D8',
            borderRadius: 6,
            backgroundColor: '#FFFFFF',
        },
        iconUploadedFileIcon: {
            width: 24,
            height: 24,
            flexShrink: 0,
        },
        iconUploadedTexts: {
            display: 'flex',
            flexDirection: 'column',
            gap: 4,
            flex: 1,
            minWidth: 0,
        },
        iconUploadedFileName: {
            fontFamily: 'Poppins',
            fontSize: 14,
            fontWeight: 600,
            lineHeight: '16px',
            color: '#2D3648',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
        },
        iconUploadedStatus: {
            fontFamily: 'Poppins',
            fontSize: 12,
            lineHeight: '16px',
            color: '#717D96',
        },
        iconUploadedDeleteBtn: {
            padding: 4,
            color: '#0E1247',
            flexShrink: 0,
        },
        iconUploadedDeleteIcon: {
            width: 24,
            height: 24,
        },
        uploadError: {
            fontSize: 12,
            color: '#FF4E4E',
            marginTop: 4,
        },
    })
);
